/**
 * Convenient filetype acceptances for file inputs.
 * Comma separated list of MIME types and file extensions.
 */
export enum Accept {
    All = "",
    Images = "image/*",
    ImageExr = ".exr,image/x-exr",
    Zip = ".zip,application/x-zip-compressed",
    Pdf = ".pdf,application/pdf",
    Text = ".txt,text/plain",
    Video = "video/*",
    Meshes = ".obj,.cmm,.fbx,.ply",
}
